/**
 * Tipos de atendimento de prescrição de óculos.
 *
 * BV_PRESCRIPTION (renovação Benefício Visão) e APOLLO_PRESCRIPTION
 * (solicitação vinda do Apollo) usam o mesmo formulário "Prescrição de óculos
 * BV" e o mesmo fluxo de tela; o backend só os distingue para resolver a
 * solicitação de origem ao gerar a receita. Toda regra de tela que vale para
 * um vale para o outro — compare por esta lista, nunca pelo literal.
 */
export const GLASSES_PRESCRIPTION_TYPES = [
  'BV_PRESCRIPTION',
  'APOLLO_PRESCRIPTION'
]

export const isGlassesPrescription = type =>
  GLASSES_PRESCRIPTION_TYPES.includes(type)
